// extracted by mini-css-extract-plugin
export default {"container":"camera-streaming-viewer_container__zlnH9"};